import { render } from "./divider.vue?vue&type=template&id=3f5a965e&scoped=true"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"

import "./divider.vue?vue&type=style&index=0&id=3f5a965e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a965e"]])

export default __exports__